export default "__VITE_ASSET__BYHrrvId__"